<template>
  <section class="card_style">
    <skeltonTitle_image v-if="loading && $route.params.id" />
    <form @submit.prevent="addOpinion()" v-else>
      <div class="main_header_style">
        <h4>{{ $t("edit card") }}</h4>
      </div>
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="image_upload">
            <label for="imageEntry" class="upload_img" v-if="imageEntry == ''">
              <img :src="Form.image ? Form.image : defaultImage" alt="user" />
            </label>
            <img
              :src="imageEntry"
              v-else-if="imageEntry"
              class="entry_image"
              alt="entry"
            />
            <input
              type="file"
              name=""
              id="imageEntry"
              class="form-control"
              @change="onFileChange"
              hidden
              accept="image/png, image/gif, image/jpeg, image/jpg"
            />
          </div>
        </div>
        <div class="col-lg-6 col-md-6 col-12">
          <div class="form-group">
            <label for="">{{ $t("title") }}</label>
            <div class="accordion" id="accordionExample1">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingOne">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="false"
                    aria-controls="collapseOne"
                  >
                    {{ $t("title") }}
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingOne"
                  data-bs-parent="#accordionExample1"
                >
                  <div class="accordion-body">
                    <div
                      class="form-group"
                      v-for="(blog_title, index) in Form.title"
                      :key="index"
                    >
                      <label for="name"
                        >{{ $t("title") }} ({{ blog_title.lang }})</label
                      >
                      <input
                        type="text"
                        :placeholder="$t('name')"
                        class="form-control"
                        :id="`name${index}`"
                        v-model="blog_title.name"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-lg-6 col-md-6 col-12">
          <div class="form-group">
            <label for="">{{ $t("describtion") }}</label>
            <div class="accordion" id="accordionExample2">
              <div class="accordion-item">
                <h2 class="accordion-header" id="headingTwo">
                  <button
                    class="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                    {{ $t("describtion") }}
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  class="accordion-collapse collapse"
                  aria-labelledby="headingTwo"
                  data-bs-parent="#accordionExample2"
                >
                  <div class="accordion-body">
                    <div
                      class="form-group"
                      v-for="(blog_content, index) in Form.description"
                      :key="index"
                    >
                      <label class="mt-3"
                        >{{ $t("describtion") }} ({{
                          blog_content.lang
                        }})</label
                      >
                      <Editor
                        v-model="blog_content.name"
                        editorStyle="height: 120px"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button type="submit" class="add btn PrimaryButton">
        {{ $t("add") }}
      </button>
    </form>
  </section>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import Editor from "primevue/editor";

import skeltonTitle_image from "@/components/skelton/skeltonTitle_image.vue";

export default {
  name: "clientOpinionAdd",
  data() {
    return {
      languages: ["ar", "en", "id"],
      options: {
        placeholder: this.$t("describtion"),
        theme: "snow",
      },
      Form: {
        description: [],
        title: [],
      },
      imageEntry: "",
      defaultImage: require("@/assets/media/image/user.png"),
      opinion_id: this.$route.params.id,
      loading: true,
    };
  },
  components: {
    Editor,
    skeltonTitle_image,
  },
  methods: {
    setAboutTitle() {
      this.languages.forEach((language) => {
        this.Form.title.push({
          lang: language,
          name: "",
        });
        this.Form.description.push({
          lang: language,
          name: "",
        });
      });
    },
    showService() {
      axios
        .get(`/fetch_about_details/${this.opinion_id}`)
        .then(({ data }) => {
          this.Form.title = data.data.titles.map((about_title) => {
            return {
              lang: about_title.locale,
              name: about_title.title,
            };
          });

          this.Form.description = data.data.descriptions.map((ele) => {
            return {
              lang: ele.locale,
              name: ele.description,
            };
          });

          this.Form.image = data.data.image;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
        });
    },

    onFileChange(event) {
      this.fileData = event.target.files[0];

      const reader = new FileReader();
      reader.readAsDataURL(this.fileData);
      reader.onload = () => (this.imageEntry = reader.result);
    },
    //fetch country

    addOpinion() {
      const formData = new FormData();

      this.Form.title.forEach((ele) => {
        formData.append(`title_${ele.lang}`, ele.name);
      });
      if(this.$route.params.type === "portal") {
        formData.append("is_portal", 1);
      }

      this.Form.description.forEach((ele) => {
        formData.append(`description_${ele.lang}`, ele.name);
      });

      if (this.fileData instanceof File) {
        formData.append("image", this.fileData);
      }

      formData.append("id", this.opinion_id);

      // formData.append("_method", "PUT");

      axios
        .post(`/website/update_about_details`, formData)
        .then(({ data }) => {
          Swal.fire({
            title: "",
            text: data.message,
            icon: "success",
          });
          this.$router.push(`/about/${this.$route.params.type === "portal" ? "portal" : "website"}`);
        })
        .catch((error) => {
          Swal.fire({
            title: "",
            text: error.response.data.message,
            icon: "error",
          });
        });
    },
  },

  created() {
    this.setAboutTitle();
    this.showService();
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style lang="scss" scoped>
.form-group {
  margin-bottom: 1rem;
}
.image_upload {
  width: 150px;
  height: 150px;
  margin-bottom: 1.5rem;
  .upload_img,
  .entry_image {
    width: 100%;
    height: 150px;
    img {
      width: 100%;
      height: 150px;
    }
  }
}
.form-group {
  label {
    margin-bottom: 0.5rem;
  }
}
.main_header_style {
  margin-bottom: 0;
}
</style>
